import qs from "qs"
import {pick, each} from "lodash"
import mixpanel from 'mixpanel-browser';
import {DEVELOPMENT, LOCAL, PRODUCTION, STAGING} from "../env/env";

interface Tracker {
    setUTMParams: (queryString: string) => void,
    setup: (env: string) => void,
    trackEvent: (name: string, data: any) => void,
}

export const getMixPanelConfigToken = (env: string): string => {
    switch (env) {
        case PRODUCTION:
            return "db23a499d137c41fe1659f21e2b6cadf"
        case STAGING:
            return "f0fba8b7964575c06ac542ae54e98ed7"
        case LOCAL:
        case DEVELOPMENT:
            return "6b4f69bfbe4249979741478bdd64b494"
        default:
            return "f0fba8b7964575c06ac542ae54e98ed7"
    }
}

/**
 * Reads query string from browser and registers any 'utm_*' strings to mixpanel for tracking.
 */
const setUTMParams = (queryString: string) => {
    if (queryString && queryString.includes("utm_")) {
        const utmTags = ["utm_term", "utm_campaign", "utm_medium", "utm_source", "utm_content", "utm_type", "utm_market", "utm_product"]

        utmTags.forEach((element) => {
            mixpanel.unregister(`${element} [last_touch]`)
        })

        const params: any = {}
        each(pick(qs.parse(queryString.replace("?", "")), utmTags), (value, key) => {
            params[`${key} [last_touch]`] = value
        })
        mixpanel.register(params)
    }
}

const trackEvent = (name: string, attributes: any) => {
    mixpanel.track(name, attributes)
}


const setup = (env: string) => {
    const token = getMixPanelConfigToken(env)
    mixpanel.init(token, {debug: env === LOCAL || env === STAGING})
}

const mixpanelFunctions: Tracker = {
    setUTMParams,
    trackEvent,
    setup
}

export default mixpanelFunctions
